import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UsePlaylistChangesProps {
  playlistId: string;
  offset?: number;
  limit?: number;
  endDate?: Date;
}

export const usePlaylistChanges = ({ playlistId, offset = 0, limit = 50, endDate }: UsePlaylistChangesProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();

  const query = useTRPCQuery(
    trpcMusicAPI.playlists.changes.queryOptions(
      { playlistId, offset, limit, endDate, ...shareTokenInput },
      { enabled: Boolean(playlistId) }
    )
  );

  return query;
};
